import { FC } from 'react';

import lockImg from '../../../../assets/icons/lock.svg';
import { Util } from '../../../../common/util/util';
import { useActions } from '../../../../hooks/useActions';
import { useUser } from '../../../../hooks/useUser';
import { IAuthTypeForm } from '../../auth.interface';

import styles from './AuthBottom.module.sass';

const AuthBottomLogin: FC<IAuthTypeForm> = ({ type }) => {
  const { setFormType } = useActions();
  const { phone_or_email } = useUser();
  const isEmail = Util.isEmail(phone_or_email);
  return (
    <div className={styles.block}>
      <div className={styles.repeat}>
        <img src={lockImg} alt="lock" />
        {type === 'email' && (
          <div onClick={() => setFormType('phone')}>Войти по телефону</div>
        )}

        {type === 'phone' && (
          <div onClick={() => setFormType('email')}>Войти по почте</div>
        )}

        {type === 'code' && (
          <>
            {isEmail ? (
              <div onClick={() => setFormType('phone')}>Войти по телефону</div>
            ) : (
              <div onClick={() => setFormType('email')}>Войти по почте</div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default AuthBottomLogin;
